import React, { useState, useEffect } from "react";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/core/styles';
import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import ImageListItemBar from '@material-ui/core/ImageListItemBar';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import InfoIcon from '@material-ui/icons/Info';
import { isBrowser } from "react-device-detect";


const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
    },
    imageList: {
        flexWrap: 'nowrap',
        transform: 'translateZ(0)',
        width: 300,
        height: 270,
    },
    imageListItem: {
        width: '300px !important',
        height: '250px !important'
    },
    imageListMobile: {
        flexWrap: 'nowrap',
        transform: 'translateZ(0)',
        width: 200,
        height: 250,
    },
    imageListItemMobile: {
        width: '200px !important',
        height: '230px !important'
    },
    icon: {
        color: 'rgba(255, 255, 255, 0.54)',
    },
    title: {
        color: theme.palette.primary.light,
        fontSize: '10px !important'
    },
    MuiImageListItemBar: {
        title: {
            fontSize: '0.75rem !important'
        }
    },
    titleBar: {
        background:
            'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
}));


const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
            </IconButton>
        ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
    imageList: {
        width: 500,
        height: 450,
    },
}))(MuiDialogActions);



export default function ImageDialog( { isDialogOpened, filtro, listaArchivos, handleCloseDialog, tipo } ) {
    const classes = useStyles();
    useEffect(() => {
        handleClickOpen();
    }, []);

    const handleClickOpen = () => {
    };

    const handleClose = () => {
        handleCloseDialog(false);
    };

    return (
        <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" 
        open={isDialogOpened}>
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                Referencia
            </DialogTitle>
            <DialogContent dividers>
                <div className={classes.root}>
                    <ImageList rowHeight={120}
                        className={ 
                        isBrowser
                        ? classes.imageList 
                        : classes.imageListMobile }
                    >
                        { 
                            listaArchivos != undefined 
                            &&
                            listaArchivos.map(
                                (item) => (
                                    ( (tipo == 'pregunta' && item.ID_PREGUNTA == filtro.pregunta) || (tipo == 'respuesta' && item.ID_PREGUNTA == filtro.pregunta && item.ID_RESPUESTA == filtro.respuesta))
                                    &&
                                        <ImageListItem key={item.ID}
                                        style={{ height: 'auto' }} cols={2}
                                            className={ 
                                            isBrowser
                                            ? classes.imageListItem 
                                            : classes.imageListItemMobile }
                                        >
                                            <img src={"data:image/png;base64," + item.BASE64} alt={item.DESCRIPCION} />
                                            {/* <ImageListItemBar
                                            title={item.DESCRIPCION}
                                            style={customTitleStyle}
                                            // subtitle={<span>by: CGR</span>}
                                            // actionIcon={
                                            //     <IconButton aria-label={`info about ${item.DESCRIPCION}`} className={classes.icon}>
                                            //         <InfoIcon />
                                            //     </IconButton>
                                            // }
                                            /> */}
                                        </ImageListItem>
                                )
                            )
                        }
                    </ImageList>
                </div>
            </DialogContent>
            {/* <DialogActions>
                <Button autoFocus onClick={handleClose} color="primary">
                    Save changes
                </Button>
            </DialogActions> */}
        </Dialog>
    );
}






{/* <ImageListItem key={item.img} className={classes.imageListItem}>
                            <img src={item.img} alt={item.title} />
                            <ImageListItemBar
                            title={item.title}
                            subtitle={<span>by: CGR</span>}
                            actionIcon={
                                <IconButton aria-label={`info about ${item.title}`} className={classes.icon}>
                                    <InfoIcon />
                                </IconButton>
                            }
                            />





                        </ImageListItem> */}


                            {/* <ImageListItemBar
                            title={item.title}
                            classes={{
                                root: classes.titleBar,
                                title: classes.title,
                            }}
                            actionIcon={
                                <IconButton aria-label={`star ${item.title}`}>
                                <StarBorderIcon className={classes.title} />
                                </IconButton>
                            }
                            /> */}